module.exports = __webpack_public_path__ + "static/img/HKACS_LOGO_20180125 (white).ec880ff.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/HKACS_LOGO_20180125 (white).png
// module id = Rwp4
// module chunks = 1